<template>
<div>
            <div class="tbl">
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col" style="width:100%; text-align: center; margin-bottom: 15px">
                    <h2>【お客様基本情報】をご記入ください</h2>
                    </div>
                </div>
                <div class="tbl-row">
                    <div class="tbl-col">
                        会社名
                        <p style="color: #BABECB; font-size: 1.2rem">個人の場合は屋号を記載してください</p>
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="company_name" class="col-two" placeholder="" required="" v-model="companyName">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        ご担当者名
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="person_in_charge" class="col-two" placeholder="" required="">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        ご担当者様電話番号
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="person_in_charge_telephone" class="col-two" placeholder="" required="">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        ご担当者様メールアドレス
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="person_in_charge_mail" class="col-two" placeholder="" required="">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        今後のフローをご確認のうえお申し込みを進めてください
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="radio" name="flow_accept" value="1">確認しました
                    </div>
                </div>
                <hr>
            </div>
            <div class="container" style="display: flex; justify-content: center; align-items: center;height: 100%;width:100%;z-index: 100;position:absolute;left:0;top:0;opacity: 1;background-color: white" v-show="isProcessing">
                <vue-loading type="spin" color="#333" :size="{ width: '50px', height: '50px' }" ></vue-loading>
            </div>
            <b>以下利用規約をご確認のうえお申し込みを進めてください</b>
            <p style="font-size: 1.5rem; font-weight: normal"><a :href="hpConfig.entry_servies[serviceId].term_url">{{ hpConfig.entry_servies[serviceId].name }}約款</a></p>
            <div class="form-info" style="margin-top: 5px">
                <input type="checkbox" name="privacy_confirm">
                利用規約に同意します<br><br>
                <div align="center">
                      <vue-recaptcha
                        sitekey="6Lc8_dsaAAAAAAcYtHJY90ISLd3zuWRt_FhUzcgE"
                        ref="invisibleRecaptcha"
                        @verify="verify"
                      ></vue-recaptcha>
                </div>
            </div>
            <div class="u-center">
                <input type="button" style="-webkit-appearance: none" value="入力内容の確認へ" class="form-btn" v-on:click="submitConfirm()" v-bind:disabled="isProcessing">
            </div>
</div>
</template>

<script>
import CommonMixin from '@/mixins'
// import axios from 'axios'
import { VueLoading } from 'vue-loading-template'
import VueRecaptcha from 'vue-recaptcha'
import {Hoge as CompanyName} from './CompanyName.js'

export default {
  name: 'CommonFormInput',
  mixins: [CommonMixin],
  mounted () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    document.head.appendChild(recaptchaScript)
    this.serviceId = (this.$route.query.id) ? this.$route.query.id : 1
  },
  computed: {
    companyName: new CompanyName(this.personInCharge)
  },
  components: {
    VueLoading,
    'vue-recaptcha': VueRecaptcha
  },
  data () {
    return {
      errors: [],
      isProcessing: false,
      isReCaptchaVerify: false,
      reCaptchaResponse: '',
      serviceId: 0,
      // Form
      // innerCompanyName: new CompanyName(),
      personInCharge: '',
      personInChargeTelephone: '',
      personInChargeMail: '',
      flowAccept: 0
    }
  },
  methods: {
    verify (res) {
      this.isReCaptchaVerify = true
      this.reCaptchaResponse = res
    },
    submitConfirm: function () {
      if (!this.isReCaptchaVerify) {
        // this.$dialog.alert('[reCaptcha]にチェックして下さい。')
        // return
      }
      // var pc = $('input[name="privacy_confirm"]')
      // if (!pc.prop('checked')) {
      //  this.$dialog.alert('利用規約について同意して下さい。')
      //  return
      // }
      alert(this.flowAccept)
    }
  }
}
</script>

<style scoped>
.tbl-col {
    text-align: left;
}
a {
    color: rgb(186, 190, 203);
}
</style>



// WEBPACK FOOTER //
// src/components/CommonEntryFormInput.vue